<template>
	<div>
		<div>
			<b-form-group :label-align="labelAlign">
				<b-input-group>
					<b-form-input
						id="senha"
						name="senha"
						class="border-right-0"
						:type="typeInput.senha"
						autocomplete="off"
						@input="v => $emit('input', v)"
						:state="validateState('senha')"
						v-validate="{ required: validate }"
						:placeholder="placeholder"
						v-model="senha.senha"
					/>
					<b-input-group-append>
						<button
							type="button"
							class="inlineBtn"
							@click="changeType('senha')"
						>
							<img :src="require(typeInput.senha === 'password'
								? '../assets/img/closedEye.svg'
								: '../assets/img/openedEye.svg')" />
						</button>
					</b-input-group-append>
				</b-input-group>
			</b-form-group>
			<b-form-group v-if="!hideConfirmPasswd" :label-align="labelAlign">
				<b-input-group>
					<b-form-input
						id="senhaConfirm"
						name="senhaConfirm"
						class="border-right-0"
						:type="typeInput.confirm"
						autocomplete="off"
						:state="validateState('senhaConfirm')"
						v-validate="'required|sameAsPassword:'+ senha.senha"
						placeholder="Confirme sua senha"
						v-model="senha.confirm"
					/>
					<b-input-group-append>
						<button
							type="button"
							class="inlineBtn"
							@click="changeType('confirm')"
						>
							<img :src="require(typeInput.confirm === 'password'
								? '../assets/img/closedEye.svg'
								: '../assets/img/openedEye.svg')" />
						</button>
					</b-input-group-append>
				</b-input-group>
			</b-form-group>
		</div>
		<div class="is-passwd-invalid p-1" v-if="!hideConfirmPasswd && senha.senha && senha.confirm && senha.senha !== senha.confirm">
			<small class="text-invalid">
				As senhas não coincidem.
			</small>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			labelAlign: {
				type: String,
				default: "left"
			},
			validate: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String,
				default: "Digite sua senha"
			},
			hideConfirmPasswd: {
				type: Boolean,
				required: false,
				default: true
			}
		},

		data () {
			return {
				typeInput: {
					senha: "password",
					confirm: "password"
				},
				senha: {
					senha: "",
					confirm: ""
				}
			};
		},

		methods: {
			changeType (type) {
				this.typeInput[type] = this.typeInput[type] === "password" ? "text" : "password";
			},

			validateState (ref) {
				let passwdError = null;
				if (
					this.veeFields[ref]
					&& (this.veeFields[ref].dirty || this.veeFields[ref].validated)
				) {
					passwdError = !this.veeErrors.has(ref);
				}

				this.$emit("passwdError", !passwdError);
				return passwdError;
			}
		}
	};
</script>

<style scoped>
	.inlineBtn {
		border: 1px solid #ced4da;
		border-radius: 5px;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	.input-senha {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
		letter-spacing: -0.05em;
		padding: 6px 12px;
	}

	.is-passwd-invalid {
		position: absolute;
		margin-top: -17px;
		border: solid 1px red;
		background-color: white;
		width: calc(100% - 32px);
		text-align: center;
	}

	.text-invalid {
		color: red;
		font-size: 1rem;
		color: red;
	}
</style>
